/*
 * @Author: Hong.Zhang
 * @Date: 2024-09-11 14:51:34
 * @Description:
 */
import cls from 'classnames';
import styles from './index.less';

export interface ICTAButtonProps {
  type?: 'primary' | 'secondary';
  text: string;
  onClick?: (...args: any[]) => void;
  htmlTypeSubmit?: boolean;
  disabled?: boolean;
  className?: any;
  innerClassName?: any;
  buttonRef?: any;
}

function CTAButton(props: ICTAButtonProps) {
  const {
    type = 'primary',
    text,
    onClick,
    htmlTypeSubmit = false,
    disabled = false,
    className,
    innerClassName,
    buttonRef,
  } = props;
  return (
    <div className={cls(styles.container, className)}>
      <button
        ref={buttonRef}
        type={htmlTypeSubmit ? 'submit' : 'button'}
        className={cls(
          {
            [styles.button]: !disabled,
            [styles.buttonDisabled]: disabled,
            [styles.secondary]: type === 'secondary',
          },
          innerClassName,
        )}
        onClick={(e: any) => {
          if (!htmlTypeSubmit && !disabled) onClick?.(e);
        }}
      >
        {text}
      </button>
    </div>
  );
}

export default CTAButton;
